import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//api
import { getBookStores} from 'api/pathForHook/company';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Head from 'components/metatags_helmet/metatags';
import LibraryCard from 'components/libraryCard/libraryCard';
import FilteredResults from 'components/userzone/FilteredResults';
import { InputCustom } from 'components/input';
import SearchByLibraryName from 'components/userzone/SearchByLibraryName';
import Button from 'components/userzone/buttons/ButtonCustom';
import TitleWithLine from 'components/titleWithLine';
//styles
import './libraries.scss';

const Libraries = () => {
  const [libraries, setLibraries] = useState([]);
  const [formFilter, setFormFilter] = useState({
    direccion: '',
    name: '',
  });
  const { t } = useTranslation(['libraries']);
  const [page, setPage] = useState(1);
  const [responseInfo, setResponseInfo] = useState({});
  const title = t('bookstores');
  const description = t('findbookstores');

  const {fetchData, stateData, loading} = useHandleSearch();
  const { assignedLibrary} = useAssignedLibrary();

  const getLibrariesAsoc = async () => {
    let payload = {
      page,
      page_size: 12,
      direccion: formFilter.direccion !== '' ? formFilter.direccion : '',
      name: formFilter.name !== '' ? formFilter.name : '',
    };
    try{
      await fetchData(getBookStores(), payload);
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    const {results, errors, totalPages, noResults} = stateData;
    if(results !== null){
      setLibraries(Array.isArray(results) ? results : []);
      setResponseInfo({errors, totalPages, noResults});
    }else{
      setLibraries([]);
      setResponseInfo({errors});
    }
  }, [stateData])

  useEffect(() => {
    getLibrariesAsoc();
  }, [page, formFilter]);


  const clearsearch = () => {
    setFormFilter({
      ...formFilter,
      direccion: '',
      name: '',
    });
  };

  return (
    <Container fluid className="justify-content-center d-flex mainDiv">
      <Head description={description} title={title} noIndex={true} />
      <Row className="libraries-row justify-content-center ">
        <Col md={6} lg={3} sm={6} xs={12} className="filter-col">
          <div className="mb-lg-5 mb-md-3" >
            <TitleWithLine text={t('bookstores')} />
          </div>
          <div>
            <InputCustom
              type="text"
              placeholder={t('adresscitytown')}
              value={formFilter.direccion}
              onChange={(e) => setFormFilter({ ...formFilter, direccion: e.target.value })}
            />
            <SearchByLibraryName
              id="name"
              filterBy="name"
              placeholder={t('searchname')}
              defaultValue={formFilter.name}
              onSelected={(item) => setFormFilter({ ...formFilter, name: item?.value })}
            />
            <Button variant="primary" onClick={clearsearch} extraClass="mt-2 size-text-mobile button-libraries">
              {t('clearsearch')}
            </Button>
            <Link to={`/${assignedLibrary}/librerias/mapa`} className="text-decoration-none">
              <Button variant="secondary" extraClass="mt-2 size-text-mobile button-libraries">{t('gobookstoremap')}</Button>
            </Link>
          </div>
        </Col>
        <Col md={12} lg={9}>
          <Row className="d-flex flex-column h-100">
            <FilteredResults
              data={libraries?.length === 0}
              noResults={responseInfo?.noResults}
              isLoading={loading}
              page={page}
              changePage={setPage}
              totalPages={responseInfo?.totalPages}
            >
              {libraries &&
                libraries?.map((item, i) => (
                  <Col sm={12} md={6} lg={4} key={i} className="mt-sm-5 mt-lg-3">
                    <LibraryCard library={item} />
                  </Col>
                ))}
            </FilteredResults>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Libraries;